"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
Entry.Board = /*#__PURE__*/function () {
  function Board(option) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Board);
    (0, _defineProperty2["default"])(this, "schema", {
      code: null,
      dragBlock: null,
      magnetedBlockView: null,
      selectedBlockView: null,
      isVisibleComment: true
    });
    Entry.Model(this, false);
    this.scale = option.scale || 1;
    this.readOnly = option.readOnly === undefined ? false : option.readOnly;
    this.changeEvent = new Entry.Event(this);
    this.createView(option);
    this.updateOffset();
    this.scroller = new Entry.Scroller(this, true, true);
    this._magnetMap = {};
    Entry.ANIMATION_DURATION = 200;
    Entry.BOARD_PADDING = 100;
    this._initContextOptions();
    Entry.Utils.disableContextmenu(this.svgDom);
    this._addControl();
    this._bindEvent();
    this.observe(this, 'handleVisibleComment', ['isVisibleComment'], false);
    Entry.addEventListener('fontLoaded', this.reDraw.bind(this));
    if (!Entry.codeChangedEvent) {
      Entry.codeChangedEvent = new Entry.Event(window);
    }
    var updateObjectBlockCount = function updateObjectBlockCount() {
      _this.updateObjectBlockCount(Entry.container.selectedObject);
    };
    Entry.codeChangedEvent.attach(this, updateObjectBlockCount);
    Entry.addEventListener('loadComplete', updateObjectBlockCount);
    Entry.Utils.setSVGDom(this.svgDom);
  }
  return (0, _createClass2["default"])(Board, [{
    key: "createView",
    value: function createView(option) {
      var dom = option.dom;
      if (typeof dom === 'string') {
        dom = $("#".concat(dom));
      } else {
        dom = $(dom);
      }
      if (dom.prop('tagName') !== 'DIV') {
        return console.error('Dom is not div element');
      }
      this.view = dom;
      this._svgId = "play".concat(new Date().getTime());
      this.workspace = option.workspace;
      this._activatedBlockView = null;
      this.wrapper = Entry.Dom('div', {
        parent: dom,
        "class": 'entryBoardWrapper'
      });
      this.svgDom = Entry.Dom($("<svg id=\"".concat(this._svgId, "\" class=\"entryBoard\" width=\"100%\" height=\"100%\"") + "version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"></svg>"), {
        parent: this.wrapper
      });
      this.visible = true;
      this.svg = Entry.SVG(this._svgId);
      $(window).scroll(this.updateOffset.bind(this));
      this.svgGroup = this.svg.elem('g');
      this.svgGroup.attr('transform', "scale(".concat(this.scale, ")"));
      this.svgObjectTitle = this.svgGroup.elem('g');
      this.svgObjectTitle.board = this;
      this.svgObjectTitle.attr({
        "class": 'svgObjectTitle'
      });
      this.svgObjectBlockCount = this.svgGroup.elem('g');
      this.svgObjectBlockCount.board = this;
      this.svgObjectBlockCount.attr({
        "class": 'svgObjectBlockCount'
      });
      this.svgThreadGroup = this.svgGroup.elem('g');
      this.svgThreadGroup.board = this;
      this.svgBlockGroup = this.svgGroup.elem('g');
      this.svgBlockGroup.board = this;
      this.svgCommentGroup = this.svgGroup.elem('g');
      this.svgCommentGroup.board = this;
      if (option.isOverlay) {
        this.wrapper.addClass('entryOverlayBoard');
        this.generateButtons();
        this.suffix = 'overlayBoard';
      } else {
        this.suffix = 'board';
      }
      Entry.Utils.addFilters(this.svg, this.suffix);
      this.pattern = Entry.Utils.addBlockPattern(this.svg, this.suffix).pattern;
    }
  }, {
    key: "changeCode",
    value: function changeCode(code, shouldNotCreateView, cb) {
      if (this.code && this.codeListener) {
        this.codeListener.destroy();
      }
      this.set({
        code: code
      });
      var that = this;
      if (code && !shouldNotCreateView) {
        this.codeListener = this.code.changeEvent.attach(this, function () {
          that.changeEvent.notify();
        });
        this.svgCommentGroup.remove();
        this.svgBlockGroup.remove();
        this.svgThreadGroup.remove();
        code.createView(this);
        if (code.isAllThreadsInOrigin()) {
          this.alignThreads();
        }
        cb && cb();
      }
      this.scroller.resizeScrollBar();
    }
  }, {
    key: "bindCodeView",
    value: function bindCodeView(codeView) {
      this.svgCommentGroup.remove();
      this.svgBlockGroup.remove();
      this.svgThreadGroup.remove();
      this.svgCommentGroup = codeView.svgCommentGroup;
      this.svgBlockGroup = codeView.svgBlockGroup;
      this.svgThreadGroup = codeView.svgThreadGroup;
      this.svgGroup.appendChild(this.svgThreadGroup);
      this.svgGroup.appendChild(this.svgBlockGroup);
      this.svgGroup.appendChild(this.svgCommentGroup);
    }
  }, {
    key: "setMagnetedBlock",
    value: function setMagnetedBlock(block, magnetType) {
      if (this.magnetedBlockView === block) {
        return;
      }
      this.magnetedBlockView && this.magnetedBlockView.set({
        magneting: false
      });
      this.set({
        magnetedBlockView: block
      });
      if (block) {
        block.set({
          magneting: magnetType
        });
        block.dominate();
      }
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this.code;
    }
  }, {
    key: "findById",
    value: function findById(id) {
      return this.code.findById(id);
    }
  }, {
    key: "_addControl",
    value: function _addControl() {
      var dom = this.svgDom;
      var that = this;
      dom.mousedown(function () {
        that.onMouseDown.apply(that, arguments);
      });
      dom.bind('touchstart', function () {
        that.onMouseDown.apply(that, arguments);
      });
      dom.on('wheel', function () {
        that.mouseWheel.apply(that, arguments);
      });
      var scroller = that.scroller;
      if (scroller) {
        dom.mouseenter(function () {
          scroller.setOpacity(0.8);
        });
        dom.mouseleave(function () {
          scroller.setOpacity(0);
        });
      }
      Entry.Utils.bindBlockViewHoverEvent(this, dom);
    }
  }, {
    key: "removeControl",
    value: function removeControl(eventType) {
      this.svgDom.off(eventType);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      if (this.workspace.getMode() == Entry.Workspace.MODE_VIMBOARD) {
        return;
      }
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      if (e.preventDefault) {
        e.preventDefault();
      }
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      if (this.workingEvent) {
        return;
      }
      this.workingEvent = true;
      if (Entry.isMobile()) {
        this.scroller.setOpacity(0.8);
      }
      var board = this;
      var longPressTimer = null;
      var dragMode = Entry.DRAG_MODE_NONE;
      if (e.button === 0 || e.originalEvent && e.originalEvent.touches) {
        var eventType = e.type;
        var mouseEvent = Entry.Utils.convertMouseEvent(e);
        if (Entry.documentMousedown) {
          Entry.documentMousedown.notify(mouseEvent);
        }
        dragMode = Entry.DRAG_MODE_MOUSEDOWN;
        var doc = $(document);
        this.mouseDownCoordinate = {
          x: mouseEvent.pageX,
          y: mouseEvent.pageY
        };
        doc.bind('mousemove.entryBoard', onMouseMove);
        doc.bind('mouseup.entryBoard', onMouseUp);
        doc.bind('touchmove.entryBoard', onMouseMove);
        doc.bind('touchend.entryBoard', onMouseUp);
        this.dragInstance = new Entry.DragInstance({
          startX: mouseEvent.pageX,
          startY: mouseEvent.pageY,
          offsetX: mouseEvent.pageX,
          offsetY: mouseEvent.pageY
        });
        if (eventType === 'touchstart' || Entry.isMobile()) {
          longPressTimer = setTimeout(function () {
            if (longPressTimer) {
              longPressTimer = null;
              onMouseUp();
              board._rightClick(e);
            }
          }, 1000);
        }
      } else if (Entry.Utils.isRightButton(e)) {
        this._rightClick(e);
      }
      function onMouseMove(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        if (e.preventDefault) {
          e.preventDefault();
        }
        var mouseEvent = Entry.Utils.convertMouseEvent(e);
        var mouseDownCoordinate = board.mouseDownCoordinate;
        var pageX = mouseEvent.pageX;
        var pageY = mouseEvent.pageY;
        var diff = Math.sqrt(Math.pow(pageX - mouseDownCoordinate.x, 2) + Math.pow(pageY - mouseDownCoordinate.y, 2));
        if (dragMode === Entry.DRAG_MODE_DRAG && diff > Entry.Board.DRAG_RADIUS || dragMode === Entry.DRAG_MODE_MOUSEDOWN && diff > Entry.Board.FIRST_DRAG_RADIUS) {
          dragMode = Entry.DRAG_MODE_DRAG;
          if (longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
          var dragInstance = board.dragInstance;
          board.scroller.scroll(pageX - dragInstance.offsetX, pageY - dragInstance.offsetY);
          dragInstance.set({
            offsetX: pageX,
            offsetY: pageY
          });
        }
      }
      function onMouseUp() {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
        if (Entry.isMobile()) {
          board.scroller.setOpacity(0);
        }
        $(document).unbind('.entryBoard');
        delete board.workingEvent;
        delete board.mouseDownCoordinate;
        delete board.dragInstance;
      }
    }
  }, {
    key: "mouseWheel",
    value: function mouseWheel(e) {
      e = e.originalEvent;
      e.preventDefault();
      var disposeEvent = Entry.disposeEvent;
      if (disposeEvent) {
        disposeEvent.notify(e);
      }
      this.scroller.scroll(e.wheelDeltaX || -e.deltaX, e.wheelDeltaY || -e.deltaY);
    }
  }, {
    key: "setSelectedBlock",
    value: function setSelectedBlock(blockView) {
      var old = this.selectedBlockView;
      if (old) {
        old.removeSelected();
      }
      if (blockView instanceof Entry.BlockView) {
        blockView.addSelected();
      } else {
        blockView = null;
      }
      this.set({
        selectedBlockView: blockView
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.wrapper.addClass('entryRemove');
      this.visible = false;
    }
  }, {
    key: "show",
    value: function show() {
      this.wrapper.removeClass('entryRemove');
      this.visible = true;
    }
  }, {
    key: "initCommentSchema",
    value: function initCommentSchema() {
      var blockMap = this.code._blockMap;
      var keys = Object.keys(blockMap) || [];
      keys.forEach(function (id) {
        var comment = blockMap[id];
        if (comment instanceof Entry.Comment) {
          comment.initSchema();
        }
      });
    }
  }, {
    key: "alignThreads",
    value: function alignThreads(reDraw) {
      var _this2 = this;
      var threads = this.code.getThreads();
      if (!threads.length) {
        return;
      }
      this.initCommentSchema();
      var verticalGap = 15;
      var acculmulatedTop = 15;
      var columWidth = 0;
      var limitTopPosition = this.svgDom.height() - 30;
      var left = 50;
      threads.forEach(function (thread) {
        var block = thread.getFirstBlock();
        if (!block) {
          return;
        }
        if (!_this2.isVisibleComment && block instanceof Entry.Comment) {
          return;
        }
        reDraw && thread.view.reDraw();
        var blockView = block.view;
        if (!blockView.movable) {
          return;
        }
        var bBox = blockView.svgGroup.getBBox();
        var top = acculmulatedTop + verticalGap;
        if (top > limitTopPosition) {
          left = left + columWidth + 10;
          columWidth = 0;
          acculmulatedTop = 15;
        }
        columWidth = Math.max(columWidth, bBox.width * _this2.scale);
        top = acculmulatedTop + verticalGap;
        if (block instanceof Entry.Block) {
          blockView.moveTo(left, top, false);
        } else {
          blockView.moveTo(left / _this2.scale, top / _this2.scale, false);
        }
        acculmulatedTop = top + bBox.height * _this2.scale;
      });
      this.scroller.resizeScrollBar();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.svgCommentGroup.remove();
      this.svgBlockGroup.remove();
      this.svgThreadGroup.remove();
      this.clearObjectTitle();
      this.clearObjectBlockCount();
    }
  }, {
    key: "updateOffset",
    value: function updateOffset() {
      this._offset = this.svg.getBoundingClientRect();
      var w = $(window);
      var scrollTop = w.scrollTop();
      var scrollLeft = w.scrollLeft();
      var offset = this._offset;
      this.relativeOffset = {
        top: offset.top - scrollTop,
        left: offset.left - scrollLeft
      };
      var svgDom = this.svgDom;
      if (svgDom) {
        this._svgDomRect = {
          width: svgDom.width(),
          height: svgDom.height()
        };
      }
      if (this.btnWrapper) {
        this.btnWrapper.attr({
          transform: "translate(".concat(offset.width / 2 - 65, ",").concat(offset.height - 200, ")")
        });
      }
    }
  }, {
    key: "generateButtons",
    value: function generateButtons() {
      this.btnWrapper = this.svg.elem('g');
      var btnWrapper = this.btnWrapper;
      var BLUE_CLASS = 'entryFunctionButtonText';
      var WHITE_CLASS = 'entryFunctionButton';
      var saveButton = btnWrapper.elem('rect', {
        x: 74,
        y: 12,
        width: 64,
        height: 32,
        rx: 4,
        ry: 4,
        "class": BLUE_CLASS
      });
      this.saveButton = saveButton;
      var cancelButton = btnWrapper.elem('rect', {
        x: 0,
        y: 12,
        width: 64,
        height: 32,
        rx: 4,
        ry: 4,
        "class": 'entryFunctionButtonBorder'
      });
      var saveText = btnWrapper.elem('text', {
        x: 106,
        y: 33,
        "class": WHITE_CLASS
      });
      saveText.textContent = Lang.Buttons.save;
      var cancelText = btnWrapper.elem('text', {
        x: 32,
        y: 33,
        "class": BLUE_CLASS
      });
      cancelText.textContent = Lang.Buttons.cancel;
      var saveFunc = this.save.bind(this);
      var cancelFunc = this.cancelEdit.bind(this);
      this.cancelButton = cancelButton;
      $(saveButton).bind('mousedown touchstart', saveFunc);
      $(saveText).bind('mousedown touchstart', saveFunc);
      $(cancelButton).bind('mousedown touchstart', cancelFunc);
      $(cancelText).bind('mousedown touchstart', cancelFunc);
    }
  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      Entry.disposeEvent.notify();
      Entry["do"]('funcEditEnd', 'cancel');
    }
  }, {
    key: "save",
    value: function save() {
      Entry.disposeEvent.notify();
      Entry["do"]('funcEditEnd', 'save');
    }
  }, {
    key: "generateCodeMagnetMap",
    value: function generateCodeMagnetMap() {
      var code = this.code;
      var dragBlock = this.dragBlock;
      if (!(code && dragBlock)) {
        return;
      }

      //reset magnetMap
      this._magnetMap = {};
      for (var targetType in dragBlock.magnet) {
        if (targetType === 'next' && dragBlock.thread &&
        // 파이썬 변환 후 basic skeleton 블록이 필드에 있는 경우 제외
        dragBlock.block.getLastBlock().view.magnet.next === undefined) {
          continue;
        }
        var metaData = this._getCodeBlocks(code, targetType).sort(function (a, b) {
          return a.point - b.point;
        });
        metaData.unshift({
          point: -Number.MAX_VALUE,
          blocks: []
        });
        for (var i = 1; i < metaData.length; i++) {
          var pointData = metaData[i];
          var includeData = pointData;
          var block = pointData.startBlock;
          if (block) {
            var limit = pointData.endPoint;
            var index = i;
            while (limit > includeData.point) {
              includeData.blocks.push(block);
              index++;
              includeData = metaData[index];
              if (!includeData) {
                break;
              }
            }
            delete pointData.startBlock;
          }
          pointData.endPoint = Number.MAX_VALUE;
          metaData[i - 1].endPoint = pointData.point;
        }
        this._magnetMap[targetType] = metaData;
      }
    }
  }, {
    key: "_getCodeBlocks",
    value: function _getCodeBlocks(code, targetType) {
      var _this3 = this;
      var func;
      switch (targetType) {
        case 'previous':
          func = this._getNextMagnets;
          break;
        case 'next':
          func = this._getPreviousMagnets;
          break;
        case 'string':
        case 'boolean':
          func = this._getFieldMagnets;
          break;
        case 'param':
          func = this._getOutputMagnets;
          break;
        default:
          return [];
      }
      return code.getThreads().reduce(function (blocks, thread) {
        return blocks.concat(func.call(_this3, thread, thread.view.zIndex, null, targetType));
      }, []);
    }
  }, {
    key: "_getNextMagnets",
    value: function _getNextMagnets(thread, zIndex, offset, targetType) {
      offset = offset ? offset : {
        x: 0,
        y: 0
      };
      var blocks = thread.getBlocks();
      var statementBlocks = [];
      var metaData = [];
      var cursorX = offset.x;
      var cursorY = offset.y;
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var blockView = block.view;
        blockView.zIndex = zIndex;
        if (blockView.dragInstance) {
          break;
        }
        cursorY += blockView.y / this.scale;
        cursorX += blockView.x;
        var endPoint = cursorY + 1;
        if (blockView.magnet.next) {
          endPoint += blockView.height;
          metaData.push({
            point: cursorY,
            endPoint: endPoint,
            startBlock: block,
            blocks: []
          });
          metaData.push({
            point: endPoint,
            blocks: []
          });
          blockView.absX = cursorX;
        }
        if (block.statements) {
          zIndex += 0.01;
          for (var j = 0; j < block.statements.length; j++) {
            var _thread = block.statements[j];
            var statement = block.view._statements[j];
            statement.zIndex = zIndex;
            statement.absX = cursorX + statement.x * this.scale;
            metaData.push({
              point: statement.y + cursorY - 30,
              endPoint: statement.y + cursorY,
              startBlock: statement,
              blocks: []
            });
            metaData.push({
              point: statement.y + cursorY + statement.height,
              blocks: []
            });
            zIndex += 0.01;
            statementBlocks = statementBlocks.concat(this._getNextMagnets(_thread, zIndex, {
              x: statement.x * this.scale + cursorX,
              y: statement.y + cursorY
            }, targetType));
          }
        }
        if (blockView.magnet.next) {
          cursorY += blockView.magnet.next.y;
          cursorX += blockView.magnet.next.x * this.scale;
        }
      }
      return statementBlocks.concat(metaData);
    }
  }, {
    key: "_getPreviousMagnets",
    value: function _getPreviousMagnets(thread, zIndex, offset) {
      offset = offset ? offset : {
        x: 0,
        y: 0
      };
      var blocks = thread.getBlocks();
      var metaData = [];
      var cursorX = offset.x;
      var cursorY = offset.y;
      var block = blocks[0];
      var blockView = block.view;
      blockView.zIndex = zIndex;
      if (blockView.dragInstance) {
        return [];
      }
      cursorY += blockView.y / this.scale - 15;
      cursorX += blockView.x;
      var endPoint = cursorY + 1;
      if (blockView.magnet.previous) {
        endPoint += blockView.height;
        metaData.push({
          point: cursorY,
          endPoint: endPoint,
          startBlock: block,
          blocks: []
        });
        metaData.push({
          point: endPoint,
          blocks: []
        });
        blockView.absX = cursorX;
        return metaData;
      }
      return [];
    }
  }, {
    key: "_getFieldMagnets",
    value: function _getFieldMagnets(thread, zIndex, offset, targetType) {
      offset = offset ? offset : {
        x: 0,
        y: 0
      };
      var blocks = thread.getBlocks();
      var statementBlocks = [];
      var metaData = [];
      var cursorX = offset.x;
      var cursorY = offset.y;
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        if (block instanceof Entry.Comment) {
          break;
        }
        if (!block.assemble) {
          break;
        }
        var blockView = block.view;
        if (blockView.dragInstance) {
          break;
        }
        blockView.zIndex = zIndex;
        cursorY += blockView.y / this.scale;
        cursorX += blockView.x;
        metaData = metaData.concat(this._getFieldBlockMetaData(blockView, cursorX, cursorY, zIndex, targetType));
        if (block.statements) {
          zIndex += 0.01;
        }
        for (var j = 0; j < block.statements.length; j++) {
          var _thread2 = block.statements[j];
          var statement = block.view._statements[j];
          statementBlocks = statementBlocks.concat(this._getFieldMagnets(_thread2, zIndex, {
            x: statement.x * this.scale + cursorX,
            y: statement.y + cursorY
          }, targetType));
        }
        if (blockView.magnet.next) {
          cursorY += blockView.magnet.next.y;
          cursorX += blockView.magnet.next.x * this.scale;
        }
      }
      return statementBlocks.concat(metaData);
    }
  }, {
    key: "_getFieldBlockMetaData",
    value: function _getFieldBlockMetaData(blockView, cursorX, cursorY, zIndex, targetType) {
      var contents = blockView._contents;
      var metaData = [];
      cursorY += blockView.contentPos.y;
      for (var i = 0; i < contents.length; i++) {
        var content = contents[i];
        if (!(content instanceof Entry.FieldBlock)) {
          continue;
        }
        var contentBlock = content._valueBlock;
        if (contentBlock.view.dragInstance) {
          continue;
        }
        var startX = cursorX + content.box.x * this.scale;
        var startY = cursorY + content.box.y + blockView.contentHeight % 1000 * -0.5;
        var endY = cursorY + content.box.y + content.box.height;
        if (content.acceptType !== targetType && content.acceptType !== 'boolean') {
          if (targetType === 'boolean') {
            var _contentBlockView = contentBlock.view;
            metaData = metaData.concat(this._getFieldBlockMetaData(_contentBlockView, startX + _contentBlockView.contentPos.x * this.scale, startY + _contentBlockView.contentPos.y, zIndex, targetType));
          }
          continue;
        }
        if (content.acceptType === targetType) {
          metaData.push({
            point: startY,
            endPoint: endY,
            startBlock: contentBlock,
            blocks: []
          });
          metaData.push({
            point: endY,
            blocks: []
          });
        }
        var contentBlockView = contentBlock.view;
        contentBlockView.absX = startX;
        contentBlockView.zIndex = zIndex;
        metaData = metaData.concat(this._getFieldBlockMetaData(contentBlockView, startX + contentBlockView.contentPos.x * this.scale, startY + contentBlockView.contentPos.y, zIndex + 0.01, targetType));
      }
      return metaData;
    }
  }, {
    key: "_getOutputMagnets",
    value: function _getOutputMagnets(thread, zIndex, offset, targetType) {
      offset = offset ? offset : {
        x: 0,
        y: 0
      };
      var blocks = thread.getBlocks();
      var statementBlocks = [];
      var metaData = [];
      var cursorX = offset.x;
      var cursorY = offset.y;
      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var blockView = block.view;
        if (blockView instanceof Entry.Comment) {
          continue;
        }
        if (blockView.dragInstance) {
          break;
        }
        blockView.zIndex = zIndex;
        cursorY += blockView.y / this.scale;
        cursorX += blockView.x;
        metaData = metaData.concat(this._getOutputMetaData(blockView, cursorX, cursorY, zIndex, targetType));
        if (block.statements) {
          zIndex += 0.01;
        }
        for (var j = 0; j < block.statements.length; j++) {
          var _thread3 = block.statements[j];
          var statement = block.view._statements[j];
          statementBlocks = statementBlocks.concat(this._getOutputMagnets(_thread3, zIndex, {
            x: statement.x * this.scale + cursorX,
            y: statement.y + cursorY
          }, targetType));
        }
        if (blockView.magnet.next) {
          cursorY += blockView.magnet.next.y;
          cursorX += blockView.magnet.next.x * this.scale;
        }
      }
      return statementBlocks.concat(metaData);
    }
  }, {
    key: "_getOutputMetaData",
    value: function _getOutputMetaData(blockView, cursorX, cursorY, zIndex, targetType) {
      var contents = blockView._contents;
      var metaData = [];
      cursorX += blockView.contentPos.x * this.scale;
      cursorY += blockView.contentPos.y;
      for (var i = 0; i < contents.length; i++) {
        var content = contents[i];
        var contentScaleX = content.box.x * this.scale;
        var startX = cursorX + contentScaleX;
        var startY = cursorY - 24;
        var endY = cursorY;
        if (content instanceof Entry.FieldBlock) {
          if (content.acceptType === targetType) {
            metaData.push({
              point: startY,
              endPoint: endY,
              startBlock: content,
              blocks: []
            });
            metaData.push({
              point: endY,
              blocks: []
            });
            content.absX = startX;
            content.zIndex = zIndex;
            content.width = 20;
          }
          var contentBlock = content._valueBlock;
          if (contentBlock) {
            metaData = metaData.concat(this._getOutputMetaData(contentBlock.view, startX, cursorY + content.box.y, zIndex + 0.01, targetType));
          }
          continue;
        } else if (content instanceof Entry.FieldOutput) {
          if (content.acceptType !== targetType) {
            continue;
          }
          metaData.push({
            point: startY,
            endPoint: endY,
            startBlock: content,
            blocks: []
          });
          metaData.push({
            point: endY,
            blocks: []
          });
          content.absX = startX;
          content.zIndex = zIndex;
          content.width = 20;
          var _contentBlock = content._valueBlock;
          if (!_contentBlock) {
            continue;
          }
          if (_contentBlock.view.dragInstance) {
            continue;
          }
          var contentBlockView = _contentBlock.view;
          metaData = metaData.concat(this._getOutputMetaData(contentBlockView, cursorX + contentScaleX, cursorY + content.box.y, zIndex + 0.01, targetType));
        }
      }
      return metaData;
    }
  }, {
    key: "getNearestMagnet",
    value: function getNearestMagnet(x, y, targetType) {
      var targetArray = this._magnetMap[targetType];
      if (!targetArray || targetArray.length === 0) {
        return;
      }
      var minIndex = 0;
      var maxIndex = targetArray.length - 1;
      var index;
      var pointData;
      var result = null;
      var searchValue = targetType === 'previous' ? y - 15 : y;
      var leftOffset = ['previous', 'next'].indexOf(targetType) > -1 ? 20 : 0;
      while (minIndex <= maxIndex) {
        index = (minIndex + maxIndex) / 2 | 0;
        pointData = targetArray[index];
        if (searchValue < pointData.point) {
          maxIndex = index - 1;
        } else if (searchValue > pointData.endPoint) {
          minIndex = index + 1;
        } else {
          var blocks = pointData.blocks;
          for (var i = 0; i < blocks.length; i++) {
            var blockView = blocks[i].view;
            var minX = blockView.absX / this.scale - leftOffset;
            var maxX = blockView.width + minX;
            if (minX < x && x < maxX) {
              var resultBlock = pointData.blocks[i];
              if (!result || result.view.zIndex < resultBlock.view.zIndex) {
                result = pointData.blocks[i];
              }
            }
          }
          return result;
        }
      }
      return null;
    }
  }, {
    key: "dominate",
    value: function dominate(thread) {
      var _this4 = this;
      if (!thread) {
        return;
      }
      var code = this.code;
      // currently top of dom
      // no need to dominate again
      if (!_shouldDominate(thread.view.zIndex, code.getMaxZIndex())) {
        return;
      }
      var block = thread.getFirstBlock();
      if (!block) {
        return;
      }

      //udpate zIndex data first
      code.dominate(thread);
      //udpate visual things next frame
      requestAnimationFrame(function () {
        var svgGroup = _.result(block && block.view, 'svgGroup');
        if (_this4.svgBlockGroup && svgGroup) {
          _this4.svgBlockGroup.appendChild(svgGroup);
        }
      });
      function _shouldDominate(zIndex, max) {
        return zIndex + 1 < max || !zIndex || !max;
      }
    }
  }, {
    key: "enablePattern",
    value: function enablePattern() {
      this.pattern.removeAttribute('style');
    }
  }, {
    key: "disablePattern",
    value: function disablePattern() {
      this.pattern.attr({
        style: 'display: none'
      });
    }
  }, {
    key: "_removeActivated",
    value: function _removeActivated() {
      if (!this._activatedBlockView) {
        return;
      }
      this._activatedBlockView.removeActivated();
      this._activatedBlockView = null;
    }
  }, {
    key: "activateBlock",
    value: function activateBlock(block) {
      var view = block.view;
      var _view$getAbsoluteCoor = view.getAbsoluteCoordinate(),
        blockX = _view$getAbsoluteCoor.x,
        blockY = _view$getAbsoluteCoor.y;
      var _this$getSvgDomRect = this.getSvgDomRect(),
        width = _this$getSvgDomRect.width,
        height = _this$getSvgDomRect.height;
      this.scroller.scroll(width / 2 - blockX, height / 2 - blockY - 100);
      view.addActivated();
      this._activatedBlockView = view;
    }
  }, {
    key: "reDraw",
    value: function reDraw() {
      this.code && this.code.view && this.code.view.reDraw();
    }
  }, {
    key: "separate",
    value: function separate(block, count, index) {
      if (typeof block === 'string') {
        block = this.findById(block);
      }
      if (block.view) {
        block.view._toGlobalCoordinate();
      }
      if (block.getBlockType() === 'output') {
        if (!count) {
          return;
        }
        var prevOutputBlock = block.getPrevOutputBlock();
        var nextOutputBlock = block;
        for (var i = 0; i < count; i++) {
          nextOutputBlock = nextOutputBlock.getOutputBlock();
        }
        block.separate(count, index);
        if (prevOutputBlock && nextOutputBlock) {
          nextOutputBlock.separate();
          nextOutputBlock.doInsert(prevOutputBlock.view._contents[1]);
        }
      } else {
        var nextBlock;
        var backupPos;
        var prevBlock = block.getPrevBlock();
        if (!prevBlock && block.thread instanceof Entry.Thread && block.thread.parent instanceof Entry.Code) {
          nextBlock = block.thread.getBlock(block.thread.indexOf(block) + count);
          if (nextBlock) {
            backupPos = nextBlock.view.getAbsoluteCoordinate();
          }
        }
        block.separate(count, index);
        if (prevBlock && prevBlock.getNextBlock()) {
          prevBlock.getNextBlock().view.bindPrev();
        } else if (nextBlock) {
          nextBlock.view._toGlobalCoordinate();
          nextBlock.moveTo(backupPos.x, backupPos.y);
        }
      }
    }
  }, {
    key: "insert",
    value: function insert(block, pointer, count) {
      // pointer can be target
      if (typeof block === 'string') {
        block = this.findById(block);
      }
      var targetBlock;
      if (pointer.length === 3) {
        // for global
        this.separate(block, count, pointer[2]);
        block.moveTo(pointer[0], pointer[1]);
      } else if (pointer.length === 4 && pointer[3] == -1) {
        // insert on top
        pointer[3] = 0;
        targetBlock = this.code.getByPointer(pointer);
        this.separate(block, count, pointer[2]);
        block = block.getLastBlock();
        targetBlock.view.bindPrev(block);
        targetBlock.doInsert(block);
      } else {
        this.separate(block, count);
        var targetObj;
        if (pointer instanceof Array) {
          targetObj = this.code.getByPointer(pointer);
        } else {
          targetObj = pointer;
        }
        if (targetObj instanceof Entry.Block) {
          if (block.getBlockType() === 'basic') {
            block.view.bindPrev(targetObj);
          }
          block.doInsert(targetObj);
        } else if (targetObj instanceof Entry.FieldStatement) {
          block.view.bindPrev(targetObj);
          targetObj.insertTopBlock(block);
        } else if (targetObj instanceof Entry.Thread) {
          targetObj = targetObj.view.getParent();
          block.view.bindPrev(targetObj);
          targetObj.insertTopBlock(block);
        } else {
          block.doInsert(targetObj);
        }
      }
    }
  }, {
    key: "adjustThreadsPosition",
    value: function adjustThreadsPosition() {
      var code = this.code;
      if (!code) {
        return;
      }
      if (!code.view) {
        return;
      }
      var threads = code.getThreads();
      if (!threads || threads.length === 0) {
        return;
      }
      threads = threads.sort(function (a, b) {
        return a.getFirstBlock().view.x - b.getFirstBlock().view.x;
      });
      var block = threads[0].getFirstBlock();
      if (block) {
        block = block.view;
        var _block$getAbsoluteCoo = block.getAbsoluteCoordinate(),
          x = _block$getAbsoluteCoo.x,
          y = _block$getAbsoluteCoo.y;
        this.scroller.scroll(50 - x, 30 - y, true);
      }
    }
  }, {
    key: "_initContextOptions",
    value: function _initContextOptions() {
      var that = this;
      var _Entry = Entry,
        _Entry$options = _Entry.options,
        options = _Entry$options === void 0 ? {} : _Entry$options;
      this._contextOptions = [{
        activated: true,
        option: {
          text: Lang.Blocks.Paste_blocks,
          enable: !!Entry.clipboard && !this.readOnly,
          callback: function callback() {
            if (Entry.clipboard.type === 'comment') {
              Entry["do"]('createComment', Entry.clipboard, that);
            } else {
              Entry["do"]('addThread', Entry.clipboard).value.getFirstBlock().copyToClipboard();
            }
          }
        }
      }, {
        activated: true,
        option: {
          text: Lang.Blocks.tidy_up_block,
          enable: !this.readOnly,
          callback: function callback() {
            that.alignThreads();
          }
        }
      }, {
        activated: true,
        option: {
          text: Lang.Blocks.Clear_all_blocks,
          enable: !this.readOnly,
          callback: function callback() {
            Entry["do"]('destroyThreads');
          }
        }
      }, {
        activated: Entry.blockSaveImageEnable && Entry.type === 'workspace' && Entry.Utils.isChrome() && !Entry.isMobile(),
        option: {
          text: Lang.Menus.save_as_image_all,
          enable: !this.readOnly,
          callback: function callback() {
            return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
              var threads, promises, images;
              return _regenerator["default"].wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    threads = that.code.getThreads();
                    promises = threads.map(function (thread) {
                      var topBlock = thread.getFirstBlock();
                      if (!topBlock) {
                        return;
                      }
                      return topBlock.view.getDataUrl();
                    });
                    _context.next = 1;
                    return Promise.all(promises);
                  case 1:
                    images = _context.sent;
                    Entry.dispatchEvent('saveBlockImages', {
                      images: images
                    });
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))();
          }
        }
      }, {
        activated: !options.commentDisable,
        option: {
          text: Lang.Blocks.add_comment,
          enable: !this.readOnly,
          callback: function callback() {
            var _that$offset = that.offset(),
              x = _that$offset.left,
              y = _that$offset.top;
            Entry["do"]('createComment', {
              id: Entry.Utils.generateId(),
              x: (Entry.ContextMenu.mouseCoordinate.x - x) / that.scale,
              y: (Entry.ContextMenu.mouseCoordinate.y - y) / that.scale
            }, that);
          }
        }
      }, {
        activated: !options.commentDisable,
        option: {
          text: Lang.Blocks.hide_all_comment,
          enable: !this.readOnly,
          callback: function callback() {
            that.isVisibleComment ? Entry["do"]('hideAllComment', that) : Entry["do"]('showAllComment', that);
          }
        }
      }];
    }
  }, {
    key: "activateContextOption",
    value: function activateContextOption(option) {
      this._contextOptions[option].activated = true;
    }
  }, {
    key: "deActivateContextOption",
    value: function deActivateContextOption(option) {
      this._contextOptions[option].activated = false;
    }
  }, {
    key: "_bindEvent",
    value: function _bindEvent() {
      var evt = Entry.documentMousedown;
      if (evt) {
        evt.attach(this, this.setSelectedBlock);
        evt.attach(this, this._removeActivated);
      }
      evt = Entry.windowResized;
      if (evt) {
        evt.attach(this, (0, _debounce["default"])(this.updateOffset, 200));
      }
    }
  }, {
    key: "offset",
    value: function offset() {
      if (!this._offset || this._offset.top === 0 && this._offset.left === 0) {
        this.updateOffset();
        return this._offset;
      }
      return this._offset;
    }
  }, {
    key: "_rightClick",
    value: function _rightClick(e) {
      delete this.workingEvent;
      var disposeEvent = Entry.disposeEvent;
      disposeEvent && disposeEvent.notify(e);
      if (!this.visible) {
        return;
      }
      var contextOptions = this._contextOptions;
      contextOptions[Entry.Board.OPTION_PASTE].option.enable = !!Entry.clipboard;
      contextOptions[Entry.Board.OPTION_DOWNLOAD].option.enable = this.code.getThreads().length !== 0;
      contextOptions[Entry.Board.VISIBLE_COMMENT].option.text = this.isVisibleComment ? Lang.Blocks.hide_all_comment : Lang.Blocks.show_all_comment;
      var _Entry$Utils$convertM = Entry.Utils.convertMouseEvent(e),
        x = _Entry$Utils$convertM.clientX,
        y = _Entry$Utils$convertM.clientY;
      Entry.ContextMenu.show(contextOptions.reduce(function (options, _ref) {
        var activated = _ref.activated,
          option = _ref.option;
        if (activated) {
          options.push(option);
        }
        return options;
      }, []), null, {
        x: x,
        y: y
      });
    }
  }, {
    key: "handleVisibleComment",
    value: function handleVisibleComment() {
      if (this.isVisibleComment) {
        this.view.removeClass('invisibleComment');
      } else {
        this.view.addClass('invisibleComment');
      }
      Entry.dispatchEvent('commentVisibleChanged');
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      query = query.concat();
      var key = query.shift();
      if (key === 'trashcan') {
        return this.workspace.trashcan.svgGroup;
      } else if (key === 'coord') {
        return {
          getBoundingClientRect: function () {
            var halfWidth = 20;
            var boardOffset = this.relativeOffset;
            return {
              top: query[1] + boardOffset.top - halfWidth,
              left: query[0] + boardOffset.left - halfWidth,
              width: 2 * halfWidth,
              height: 2 * halfWidth
            };
          }.bind(this)
        };
      } else if (key === 'cancelEditButton') {
        return this.cancelButton;
      } else if (key === 'saveButton') {
        return this.saveButton;
      } else if (key instanceof Array) {
        var targetObj = this.code.getByPointer(key);
        if (targetObj.getDom) {
          return targetObj.getDom(query);
        } else {
          return targetObj.svgGroup;
        }
      }
    }
  }, {
    key: "findBlock",
    value: function findBlock(block) {
      if (typeof block === 'string') {
        return this.findById(block);
      } else if (block && block.id) {
        return this.findById(block.id) || block;
      } else if (block instanceof Array) {
        return this.code.getByPointer(block);
      }
      return block;
    }
  }, {
    key: "scrollToPointer",
    value: function scrollToPointer(pointer) {
      var obj = this.code.getByPointer(pointer);
      var pos;
      if (obj instanceof Entry.Block) {
        pos = obj.view.getAbsoluteCoordinate();
        obj.view.dominate();
      } else if (obj instanceof Entry.Thread) {
        pos = obj.view.requestAbsoluteCoordinate();
      } else if (obj.getAbsolutePosFromBoard) {
        pos = obj.getAbsolutePosFromBoard();
      }
      var newX = 0;
      var newY = 0;
      var offset = this._offset;
      var width = offset.width;
      var height = offset.height;
      if (pos.x > width - 200) {
        newX = width - 200 - pos.x;
      } else if (pos.x < 100) {
        newX = 100 - pos.x;
      }
      if (pos.y > height - 200) {
        newY = height - 200 - pos.y;
      } else if (pos.y < 100) {
        newY = 100 - pos.y;
      }
      this.scroller.scroll(newX, newY, true);
      return [newX, newY];
    }
  }, {
    key: "getSvgDomRect",
    value: function getSvgDomRect() {
      if (!this._svgDomRect) {
        this.updateOffset();
      }
      return this._svgDomRect;
    }
  }, {
    key: "setScale",
    value: function setScale() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.scale = scale;
      this.svgGroup.attr('transform', "scale(".concat(scale, ")"));
      this.adjustThreadsPosition();
    }
  }, {
    key: "updateObjectTitle",
    value: function updateObjectTitle(object) {
      if (!object) {
        this.clearObjectTitle();
        return;
      }
      if (!this.svgObjectTitle.thumbnail) {
        var thumbnail = this.svgObjectTitle.elem('g');
        var rect = thumbnail.elem('rect');
        rect.attr({
          x: 14,
          y: 12,
          rx: 2,
          ry: 2,
          width: 24,
          height: 24,
          fill: 'none',
          stroke: '#e2e2e2',
          strokeWidth: '1'
        });
        var image = thumbnail.elem('image');
        image.addClass('entryBoardObjectThumbnail');
        image.attr({
          x: 17,
          y: 15,
          width: 18,
          height: 18,
          href: object.thumbUrl
        });
        this.svgObjectTitle.frame = rect;
        this.svgObjectTitle.thumbnail = image;
      }
      if (!this.svgObjectTitle.name) {
        var name = this.svgObjectTitle.elem('g');
        var nameText = name.elem('text');
        nameText.addClass('entryBoardObjectName');
        nameText.attr({
          x: 44,
          y: 26,
          fill: '#6b6b6b'
        });
        nameText.style.font = "12px NanumGothicBold, 'Nanum Gothic'";
        nameText.textContent = object.name;
        this.svgObjectTitle.name = nameText;
      }
      this.svgObjectTitle.thumbnail.attr({
        href: object.thumbUrl
      });
      this.svgObjectTitle.name.textContent = object.name;
      this.updateObjectBlockCount(object);
    }
  }, {
    key: "updateObjectBlockCount",
    value: function () {
      var _updateObjectBlockCount = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(object) {
        var _this$svgObjectTitle,
          _this5 = this;
        var rect, countText, nameWidth, x, blocks, count, langText;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.suffix !== 'board' || !object)) {
                _context2.next = 1;
                break;
              }
              this.clearObjectBlockCount();
              return _context2.abrupt("return");
            case 1:
              if (!this.svgObjectBlockCount.rect) {
                rect = this.svgObjectBlockCount.elem('rect');
                rect.attr({
                  rx: 10,
                  ry: 10,
                  height: 20,
                  fill: '#ffffff',
                  stroke: '#d6e9f4',
                  strokeWidth: '1'
                });
                this.svgObjectBlockCount.rect = rect;
              }
              if (!this.svgObjectBlockCount.countText) {
                countText = this.svgObjectBlockCount.elem('text');
                countText.style.font = "12px NanumGothic, 'Nanum Gothic'";
                countText.attr({
                  fill: '#6b6b6b'
                });
                this.svgObjectBlockCount.countText = countText;
              }
              nameWidth = Math.round(((_this$svgObjectTitle = this.svgObjectTitle) === null || _this$svgObjectTitle === void 0 || (_this$svgObjectTitle = _this$svgObjectTitle.name) === null || _this$svgObjectTitle === void 0 ? void 0 : _this$svgObjectTitle.getBoundingClientRect().width) || 0) / this.scale;
              x = nameWidth + 8;
              this.svgObjectBlockCount.countText.attr({
                x: 44 + x + 8,
                y: 26
              });
              requestAnimationFrame(function () {
                if (!_this5.svgObjectBlockCount.countText) {
                  return;
                }
                var rectWidth = _this5.svgObjectBlockCount.countText.getBoundingClientRect().width / _this5.scale;
                _this5.svgObjectBlockCount.rect.attr({
                  width: rectWidth + 16,
                  x: 44 + x,
                  y: 12
                });
              });
              _context2.next = 2;
              return Entry.Utils.getObjectsBlocksForEventThread(object);
            case 2:
              blocks = _context2.sent;
              count = (0, _get2["default"])(blocks, 'length', 0);
              langText = Lang.Workspace.use_blocks_project;
              if (count === 1) {
                langText = Lang.Workspace.use_block_project;
              }
              if (this.svgObjectBlockCount.countText) {
                this.svgObjectBlockCount.countText.textContent = Entry.Utils.stringFormat(langText, Entry.Utils.shortenNumber(count));
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateObjectBlockCount(_x) {
        return _updateObjectBlockCount.apply(this, arguments);
      }
      return updateObjectBlockCount;
    }()
  }, {
    key: "clearObjectTitle",
    value: function clearObjectTitle() {
      var _this$svgObjectTitle$, _this$svgObjectTitle$2, _this$svgObjectTitle$3;
      if (!this.svgObjectTitle) {
        return;
      }
      (_this$svgObjectTitle$ = this.svgObjectTitle.frame) === null || _this$svgObjectTitle$ === void 0 || _this$svgObjectTitle$.remove();
      (_this$svgObjectTitle$2 = this.svgObjectTitle.thumbnail) === null || _this$svgObjectTitle$2 === void 0 || _this$svgObjectTitle$2.remove();
      (_this$svgObjectTitle$3 = this.svgObjectTitle.name) === null || _this$svgObjectTitle$3 === void 0 || _this$svgObjectTitle$3.remove();
      delete this.svgObjectTitle.frame;
      delete this.svgObjectTitle.thumbnail;
      delete this.svgObjectTitle.name;
    }
  }, {
    key: "clearObjectBlockCount",
    value: function clearObjectBlockCount() {
      var _this$svgObjectBlockC, _this$svgObjectBlockC2;
      if (!this.svgObjectBlockCount) {
        return;
      }
      (_this$svgObjectBlockC = this.svgObjectBlockCount.rect) === null || _this$svgObjectBlockC === void 0 || _this$svgObjectBlockC.remove();
      (_this$svgObjectBlockC2 = this.svgObjectBlockCount.countText) === null || _this$svgObjectBlockC2 === void 0 || _this$svgObjectBlockC2.remove();
      delete this.svgObjectBlockCount.rect;
      delete this.svgObjectBlockCount.countText;
    }
  }], [{
    key: "OPTION_PASTE",
    get: function get() {
      return 0;
    }
  }, {
    key: "OPTION_ALIGN",
    get: function get() {
      return 1;
    }
  }, {
    key: "OPTION_CLEAR",
    get: function get() {
      return 2;
    }
  }, {
    key: "OPTION_DOWNLOAD",
    get: function get() {
      return 3;
    }
  }, {
    key: "ADD_COMMENT",
    get: function get() {
      return 4;
    }
  }, {
    key: "VISIBLE_COMMENT",
    get: function get() {
      return 5;
    }
  }, {
    key: "DRAG_RADIUS",
    get: function get() {
      return 5;
    }
  }, {
    key: "FIRST_DRAG_RADIUS",
    get: function get() {
      return 10;
    }
  }]);
}();